function isPlainObject(v: unknown): v is Record<string, unknown> {
  return v !== null && typeof v === "object" && !Array.isArray(v);
}

function extractDocLayer(
  raw: Record<string, unknown>
): Record<string, unknown> {
  const inner = raw._doc;
  if (isPlainObject(inner)) {
    return { ...inner };
  }
  const { $__, $isNew, ...rest } = raw;
  void $__;
  void $isNew;
  return { ...rest };
}

function normalizeNestedRef(
  ref: Record<string, unknown> | null
): Record<string, unknown> | null {
  if (!ref) {
    return null;
  }
  const inner = ref._doc;
  if (isPlainObject(inner)) {
    return { ...inner };
  }
  const { $__, $isNew, ...rest } = ref;
  void $__;
  void $isNew;
  return { ...rest };
}

export function normalizeBusinessWalletTransaction(
  raw: unknown
): Record<string, unknown> {
  if (!isPlainObject(raw)) {
    return {};
  }

  const base = extractDocLayer(raw);

  if (raw.fees !== undefined && base.fees === undefined) {
    base.fees = raw.fees;
  }
  if (raw.source !== undefined && base.source === undefined) {
    base.source = raw.source;
  }
  if (raw.destination !== undefined && base.destination === undefined) {
    base.destination = raw.destination;
  }

  const ref = base.transactionRef;
  if (isPlainObject(ref)) {
    const plain = normalizeNestedRef(ref);
    if (plain) {
      base.transactionRef = plain;
    }
  }

  return base;
}
